import { Hero, SkillStrip } from "@/components/home/Hero";
import { About, AILearning, TopCourses, Upcoming } from "@/components/home/Sections";
import { StatsMission, InstructorSlider, WhyChoose, Stories, Community, Packages } from "@/components/home/Sections2";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <SkillStrip />
      <About />
      <AILearning />
      <TopCourses />
      <Upcoming />
      <StatsMission />
      <InstructorSlider />
      <WhyChoose />
      <Stories />
      <Community />
      <Packages />
    </div>
  );
}
